import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      height={512}
      viewBox="0 0 512 512"
      width={512}
      xmlns="http://www.w3.org/2000/svg"
      data-name="filled outline"
      {...props}
    >
      <path
        d="M120 496V302.833A46.833 46.833 0 01166.833 256h178.334A46.833 46.833 0 01392 302.833V496z"
        fill="#faa6a6"
      />
      <path d="M160 312h16v184h-16zM336 312h16v184h-16z" fill="#e88080" />
      <path d="M440 352H304v-16h128v-88h16v96a8 8 0 01-8 8z" fill="#e5e5e5" />
      <circle cx={440} cy={232} fill="#afeaef" r={24} />
      <path d="M376 408h72v16h-72z" fill="#e5e5e5" />
      <circle cx={464} cy={416} fill="#afeaef" r={24} />
      <rect fill="#faa6a6" height={48} rx={24} width={224} x={144} y={112} />
      <path
        d="M280 216v40a24 24 0 01-24 24 24 24 0 01-24-24v-40z"
        fill="#faa6a6"
      />
      <path
        d="M248 256v-40h-16v40a24 24 0 0032 22.629A24.006 24.006 0 01248 256z"
        fill="#e88080"
      />
      <path
        d="M176 96v71.879A64.121 64.121 0 00240.121 232h31.758A64.121 64.121 0 00336 167.879V96l-64-40h-48z"
        fill="#faa6a6"
      />
      <path
        d="M200 167.879V96l48-40h-24l-48 40v71.879A64.121 64.121 0 00240.121 232h24A64.121 64.121 0 01200 167.879z"
        fill="#e88080"
      />
      <path
        d="M235.37 106.243a66.165 66.165 0 008.262-10.079L256 77.612a70.2 70.2 0 0066.6 48 51.63 51.63 0 0013.4-1.782V96l-64-40h-48l-47.723 39.77q-.277 2.945-.277 5.963v23.879h12.607a66.134 66.134 0 0046.763-19.369z"
        fill="#e88080"
      />
      <path
        d="M188.607 112a66.13 66.13 0 0046.763-19.37 66.068 66.068 0 008.262-10.079L256 64a70.2 70.2 0 0066.6 48 51.673 51.673 0 0036.539-15.135L368 88h-.072a40.109 40.109 0 01-36.967-24.838 64.359 64.359 0 00-23.341-28.285A51.272 51.272 0 00256 32a51.272 51.272 0 00-51.62 2.877A64.059 64.059 0 00176 88.121V112z"
        fill="#f7b023"
      />
      <path
        d="M350.817 84.138a51.614 51.614 0 01-12.217 1.474 70.2 70.2 0 01-66.6-48l-12.368 18.552a66.165 66.165 0 01-8.262 10.079 66.134 66.134 0 01-46.763 19.369H192V61.733a64.078 64.078 0 012.884-19.046A63.918 63.918 0 00176 88.121V112h12.607a66.135 66.135 0 0046.763-19.37 66.109 66.109 0 008.262-10.078L256 64a70.2 70.2 0 0066.6 48 51.673 51.673 0 0036.539-15.135L368 88h-.072a39.1 39.1 0 01-17.111-3.862z"
        fill="#f99321"
      />
      <path
        d="M208 168h96a7.977 7.977 0 001.94-.239l30.06-7.515v-16.492L303.016 152h-94.032L176 143.754v16.492l30.06 7.515A7.977 7.977 0 00208 168z"
        fill="#e5e5e5"
      />
      <path
        d="M208 160v63.365A63.791 63.791 0 00240.121 232h31.758A63.791 63.791 0 00304 223.365V160z"
        fill="#afeaef"
      />
      <path
        d="M295.879 208H263.77A32.185 32.185 0 01232 175.684V160h-24v63.365A63.791 63.791 0 00240.121 232h31.758A63.791 63.791 0 00304 223.365v-15.883a64.57 64.57 0 01-8.121.518z"
        fill="#77d5d8"
      />
      <path d="M216 120h16v16h-16z" fill="#e88080" />
      <path
        d="M194.343 365.657l-112-112A8 8 0 0180 248v-56h16v52.687l109.657 109.656z"
        fill="#e5e5e5"
      />
      <path d="M280 120h16v16h-16z" fill="#e88080" />
      <path d="M24 40h128v160H24z" fill="#3b9daf" />
      <path d="M352 376h40v72h-40z" fill="#066991" />
      <path
        d="M108.438 126.656l-8.876-13.312L120 99.719V56h16v48a8 8 0 01-3.562 6.656z"
        fill="#e88080"
      />
      <path
        d="M104 80.49A8.49 8.49 0 0095.51 72 39.51 39.51 0 0056 111.51v58.753a8.49 8.49 0 0012.287 7.593l16.86-8.43A34.106 34.106 0 00104 138.921z"
        fill="#ce3521"
      />
      <g fill="#066991">
        <path d="M400 72h16v16h-16zM432 72h56v16h-56zM400 104h80v16h-80zM400 136h56v16h-56zM472 136h16v16h-16z" />
      </g>
      <path d="M200 166.246l-24-6v-16.492l24 6z" fill="#b7b7b7" />
      <path d="M280 368h16v16h-16zM208 368h16v16h-16z" fill="#e88080" />
      <path
        d="M260.971 324a16.971 16.971 0 0124 0l4 4 4-4a16.971 16.971 0 0124 0 16.971 16.971 0 010 24l-28 28-28-28a16.97 16.97 0 010-24z"
        fill="#ce3521"
      />
      <path
        d="M336 496H176V384a160.567 160.567 0 00132.411 108.551z"
        fill="#e88080"
      />
      <path d="M176 448h64v16h-64z" fill="#e5e5e5" />
      <rect
        fill="#3b9daf"
        height={112}
        rx={16.133}
        width={160}
        x={24}
        y={376}
      />
      <path
        d="M152 480v-47.572A32.427 32.427 0 00119.572 400H98.11A10.109 10.109 0 0188 389.89V384H56v32a24 24 0 0024 24 24 24 0 0124 24v16z"
        fill="#faa6a6"
      />
      <path
        d="M120 458.246V456a24.11 24.11 0 00-24.078-24A24 24 0 0172 408v-24H56v32a24.11 24.11 0 0024.078 24A24 24 0 01104 464v16h48v-8h-18.246A13.754 13.754 0 01120 458.246z"
        fill="#e88080"
      />
      <path d="M464 384a32.057 32.057 0 00-30.987 24H400v-56h40a8 8 0 008-8v-81.013a32 32 0 10-16 0V336h-32v-33.167A54.9 54.9 0 00345.167 248H288v-9.839A72.231 72.231 0 00344 168a31.992 31.992 0 0014.884-60.315 60.5 60.5 0 005.908-5.163l8.865-8.865A8 8 0 00368 80h-.221a32.125 32.125 0 01-29.45-19.954 72.11 72.11 0 00-26.244-31.808A59.148 59.148 0 00256 23.187a59.15 59.15 0 00-56.085 5.052A72.071 72.071 0 00168 88.121V104a32 32 0 000 64 72.231 72.231 0 0056 70.161V248h-57.167a54.789 54.789 0 00-44.569 22.95L96 244.687V208h56a8 8 0 008-8v-16h-16v8H32V48h112v40h16V40a8 8 0 00-8-8H24a8 8 0 00-8 8v160a8 8 0 008 8h56v40a8 8 0 002.343 5.657l32.319 32.32A54.61 54.61 0 00112 302.833V368H40.133A24.16 24.16 0 0016 392.133v79.734A24.16 24.16 0 0040.133 496h127.734A24.16 24.16 0 00192 471.867V464h48v-16h-48v-55.867A24.159 24.159 0 00168 368v-28.686l26.343 26.343 11.314-11.314L168 316.686V312h-4.686l-29.529-29.529A38.838 38.838 0 01166.833 264h58.18a32 32 0 0061.974 0h58.18A38.876 38.876 0 01384 302.833V336h-24v-24h-16v24h-14.071a24.959 24.959 0 00-40.958-19.173 24.971 24.971 0 00-33.657 36.83l28 28a8 8 0 0011.314 0l28-28a24.914 24.914 0 001.508-1.657H344v136h16v-32h24v40h16v-72h33.013A32 32 0 10464 384zm-40-152a16 16 0 1116 16 16.019 16.019 0 01-16-16zM40.133 480A8.142 8.142 0 0132 471.867v-79.734A8.142 8.142 0 0140.133 384H48v32a32.037 32.037 0 0032 32 16.019 16.019 0 0116 16v16zM112 480v-16a32.036 32.036 0 00-32-32 16.019 16.019 0 01-16-16v-32h16v5.89A18.13 18.13 0 0098.11 408h21.462A24.455 24.455 0 01144 432.428V480zm64-87.867v79.734a8.142 8.142 0 01-8.133 8.133H160v-47.572A40.474 40.474 0 00119.572 392H98.11a2.112 2.112 0 01-2.11-2.11V384h71.867a8.142 8.142 0 018.133 8.133zm-24-68.819V368h-24v-65.167c0-1.134.059-2.254.155-3.364zM216 168h80v50.542A55.771 55.771 0 01271.879 224h-31.758A55.771 55.771 0 01216 218.542zm96 39.066v-40.82l16-4v5.633a55.926 55.926 0 01-16 39.187zM344 152v-32a16 16 0 010 32zM184 88.121a56.093 56.093 0 0124.845-46.6 43.243 43.243 0 0143.555-2.376 8 8 0 007.2 0 43.251 43.251 0 0143.555 2.37 56.146 56.146 0 0120.438 24.763 48.578 48.578 0 0027.883 26.813A43.35 43.35 0 01322.6 104a62.119 62.119 0 01-59.01-42.529 8 8 0 00-6.528-5.4A8.124 8.124 0 00256 56a8 8 0 00-6.654 3.562l-12.369 18.551a58.253 58.253 0 01-7.265 8.861A57.75 57.75 0 01188.608 104H184zM188.608 120a73.647 73.647 0 0052.418-21.712 74.319 74.319 0 009.263-11.3l4.335-6.5A78.1 78.1 0 00322.6 120q2.721 0 5.4-.239v25.993L303.016 152h-94.032L184 145.754V120zM152 136a16.019 16.019 0 0116-16v32a16.019 16.019 0 01-16-16zm32 31.879v-5.633l16 4v40.82a55.926 55.926 0 01-16-39.187zM256 272a16.019 16.019 0 01-16-16v-16H272v16a16.019 16.019 0 01-16 16zm55.314 70.343l-22.343 22.344-22.344-22.344a8.971 8.971 0 010-12.686 8.981 8.981 0 0112.686 0l4 4a8 8 0 0011.314 0l4-4a8.97 8.97 0 0112.686 12.686zM384 352v16h-24v-16zm0 88h-24v-56h24v24h-8v16h8zm80-8a16 16 0 1116-16 16.019 16.019 0 01-16 16z" />
      <path d="M216 120h16v16h-16zM280 120h16v16h-16zM136 104V56h-16v43.719l-20.437 13.625 8.875 13.312 24-16A8 8 0 00136 104z" />
      <path d="M112 88v-7.511A16.508 16.508 0 0095.51 64 47.563 47.563 0 0048 111.51v58.753a16.466 16.466 0 0023.865 14.749l16.86-8.43A41.878 41.878 0 00112 138.921V136H96v2.921a25.962 25.962 0 01-14.432 23.35L64.71 170.7a.49.49 0 01-.71-.438V111.51A31.545 31.545 0 0195.51 80a.491.491 0 01.49.489V88zM400 72h16v16h-16zM432 72h56v16h-56zM400 104h80v16h-80zM400 136h56v16h-56zM472 136h16v16h-16z" />
    </svg>
  );
}

export default SvgComponent;
